// 25.01.19
import * as React from "react";
import logo from "../../uniceflogo.png";
import {
  AppBar,
  Toolbar,
  withStyles,
  WithStyles,
  Drawer,
  Divider,
  Tooltip,
  Icon,
  createStyles,
  Theme,
  Button,
  Menu,
  MenuItem,
  Grid,
} from "@material-ui/core";
import { AccessTypeEnum, ACCESS_REQUEST_PATH, ERROR_PATH, LOGIN_PATH, SIGN_OUT_PATH, UserRoles, USERS_PATH } from "src/constants/api"; //testUsers,
import { connect } from "react-redux";
import { fetchUserData, userDataReceived } from "src/actions/home";
import { IRootState } from "src/reducers";
import { newCase } from "src/actions/detail";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { headerStyles, navStyles, A, CustomButton } from "src/styles/general";

import Input from "@material-ui/icons/Input";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

// import { UserAgentApplication } from "msalx";

import { loggedIn } from "src/actions/common";
import { getLoggedInCurrentUserDetails } from "src/utils";
import * as Msal from "msal";
import { history } from "../../store/config";
import { resetAuthenticationStatus } from "../user-profile/actions";
import { useLocation } from "react-router-dom";
// This interface describes the arguments that the header can receive.

// interface IHeaderStateProps {
//   currentUser?: IUserDetail;
//   newCase: () => void;
//   fetchUserData: typeof fetchUserData;
//   userDataReceived: typeof userDataReceived;
//   loggedIn: typeof loggedIn;
//   username: string;
// }
/**/

// interface IHeaderDispatchProps {
//   fetchUserData: typeof fetchUserData;
//   userDataReceived: typeof userDataReceived;
// }
// type HeaderProps = IHeaderDispatchProps &
//   RouteComponentProps<IFormWrapperParams> &
//   IHeaderStateProps &
//   WithStyles<typeof joinedStyles>;

// interface IHeaderState {
//   drawerOpen: boolean;
//   isLoggedIn: boolean;
//   message: string;
//   loggedInUser: any;
//   username: string;
//   anchorEl: any;
// }

// Simple utility component for rendering the waffle icon
// @ts-ignore
const WaffleIcon = withStyles(navStyles)(
  (props: WithStyles<typeof navStyles>) => {
    const { classes } = props;
    const classNames = ["ms-Icon", "ms-Icon--Waffle", classes.waffleIcon].join(
      " "
    );
    return <span className={classNames} />;
  }
);



//loggedInUser:IAADUserDetails;
export class Header extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoggedIn: false,
      message: "",
      drawerOpen: false,
      username: "",
      loggedInUser: {} as any,
      anchorEl: null,
      anchorMenu: null,
    };
  }

  msalConfig: any = (window as any).window.msalConfig;
  newClientApplication: any = new Msal.UserAgentApplication(this.msalConfig);
  b2cPolicies: any = (window as any).b2cPolicies;
  accessToken: any = "";

  public componentDidMount() {


    if (!this.props.isUserAuthenticated) {
      this.setState({
        isLoggedIn: false,
        username: "",
        loggedInUser: {},
      });
      this.props.loggedIn(false);
      this.props.userDataReceived(undefined);
    }
  }

  public componentDidUpdate(preProps: any) {
    if (!this.state.isLoggedIn && this.props.isUserAuthenticated && this.props.currentUser) {
      const userDetails = getLoggedInCurrentUserDetails(this.props.currentUser);
      this.setState({
        isLoggedIn: true,
        username: userDetails.name,// getLoggedInUserName(),
        loggedInUser: userDetails,
      });
      this.props.loggedIn(true);
    }
  }


  public render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <AppBar className={classes.appBar} position="fixed">
          <Toolbar className={classes.navToolbar}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={3}
                style={{ display: "flex", alignItems: "center" }}
              >
                {this.renderLogo()}
              </Grid>
              <Grid item xs={6}>
                {this.renderNav()}
              </Grid>
              <Grid item xs={3}>
                {this.state.isLoggedIn ? this.renderUserDisplay() : ""}
              </Grid>
            </Grid>
            {/* {this.renderWaffleIcon()} */}
            {/* {this.renderLogo()}
            {this.renderNav()}
            {this.state.isLoggedIn ? this.renderUserDisplay() : ""} */}
          </Toolbar>
          {this.state.isLoggedIn ? this.renderDrawer() : ""}
        </AppBar>
      </React.Fragment>
    );
  }

  // Renders the top left waffle icon
  // @ts-ignore
  public renderWaffleIcon() {
    // const { classes } = this.props;
    return (
      <div />
      // <div className={classes.waffleIconContainer}>
      //   <WaffleIcon />
      // </div>
    );
  }

  // Renders the temporary drawer when the waffle button is pressed
  // Currently the drawer has no content
  public renderDrawer() {
    const { classes } = this.props;
    if (this.state.isLoggedIn && this.props.currentUser) {
      return (
        <Drawer
          onClose={this.closeDrawer}
          className={classes.drawer}
          variant="temporary"
          open={this.state.drawerOpen}
          anchor="right"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>My account</div>
          <Divider style={{ marginBottom: 40 }} />
          <div>
            <div style={{ display: "table-cell" }}>
              <div
                className={this.props.classes.circleStyle}
                style={{
                  width: "64px",
                  height: "64px",
                  top: "auto",
                  left: 25,
                  fontSize: "36px",
                  lineHeight: "60px",
                }}
              >
                {this.props.currentUser.userName.substring(0, 1).toUpperCase()}
              </div>
            </div>
            <div className={this.props.classes.personaDetails}>
              <div style={{ fontSize: "17px", textOverflow: "ellipsis" }}>
                {this.state.username}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textOverflow: "ellipsis",
                  paddingTop: "5px",
                }}
              >
                ({this.state.loggedInUser!.emails})
              </div>
              <div
                style={{
                  fontSize: "14px",
                  textOverflow: "ellipsis",
                  paddingTop: "5px",
                }}
              >
                {this.props.currentUser!.roleId === UserRoles.Solution_Owner
                  ? "Solution Provider"
                  : this.props.currentUser!.role!.name}
              </div>
            </div>
            <div className={this.props.classes.drawerMenuContainer}>
              <Button
                className={this.props.classes.drawerMenuContainerLink}
                variant="outlined"
                color="primary"
                startIcon={<ExitToAppIcon />}
                onClick={() => this.logout()}
              >
                Sign Out
              </Button>
            </div>
          </div>
        </Drawer>
      );
    } else {
      return (
        <Drawer
          onClose={this.closeDrawer}
          className={classes.drawer}
          variant="temporary"
          open={this.state.drawerOpen}
          anchor="right"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerHeader}>You are Logged in As Guest</div>
          <Divider style={{ marginBottom: 40 }} />
          <div>
            <div style={{ display: "table-cell" }}>
              <div
                className={this.props.classes.circleStyle}
                style={{
                  width: "64px",
                  height: "64px",
                  top: "auto",
                  left: 25,
                  fontSize: "36px",
                  lineHeight: "60px",
                }}
              >
                {this.state.username.substring(0, 1).toUpperCase()}
              </div>
            </div>

            <div className={this.props.classes.personaDetails}>
              <div style={{ fontSize: "17px", textOverflow: "ellipsis" }}>
                {this.state.username}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  textOverflow: "ellipsis",
                  paddingTop: "5px",
                }}
              >
                ({this.state.loggedInUser!.emails})``
              </div>
              <div
                style={{
                  fontSize: "14px",
                  textOverflow: "ellipsis",
                  paddingTop: "5px",
                }}
              >
                Guest
              </div>
            </div>
            <div className={this.props.classes.drawerMenuContainer}>
              <Button
                className={this.props.classes.drawerMenuContainerLink}
                variant="outlined"
                color="primary"
                startIcon={<ExitToAppIcon />}
                onClick={() => this.logout()}
              >
                Sign Out
              </Button>
            </div>
          </div>
        </Drawer >
      );
    }
  }

  // render the logo
  private renderLogo = () => {
    const { classes } = this.props;
    return (
      <div className={classes.logoContainer}>
        <img src={logo} className="App-logo" alt="UNICEF" />
      </div>
    );
  };

  private openDrawer = () => {
    this.setState({ drawerOpen: true });
  };
  private closeDrawer = () => {
    this.setState({ drawerOpen: false });
  };

  // private renderLoginButton=()=>{
  //   //const { loginRedirect } = this.props;
  //   return (
  //     <button onClick={() => this.loginRedirect()}>Login</button>
  //   );
  // }
  public loginRedirect() {
    history.replace(LOGIN_PATH);
    window.location.reload();
  }

  public logout() {
    localStorage.clear();
    sessionStorage.clear();

    this.setState({
      isLoggedIn: false,
      username: "",
      loggedInUser: null,
    });

    this.props.loggedIn(false);

    this.props.resetAuthenticationStatus();
    this.props.userDataReceived(undefined);

    history.replace(SIGN_OUT_PATH);
    window.location.reload();
  }

  // Displays the currently logged in user
  private renderUserDisplay = () => {
    if (this.props.currentUser) {
      return (
        this.props.currentUser && (
          <Tooltip title={this.props.currentUser.userName}>
            <Icon>
              {/* <AccountCircle onClick={this.openDrawer} width="50px" /> */}
              <div
                onClick={this.openDrawer}
                className={this.props.classes.circleStyle}
              >
                {this.props.currentUser.userName.substring(0, 1).toUpperCase()}
              </div>
            </Icon>
          </Tooltip>
        )
      );
    } else {
      return (
        <Tooltip title={this.state.username}>
          <Icon>
            <div
              onClick={this.openDrawer}
              className={this.props.classes.circleStyle}
            >
              {this.state.username.substring(0, 1).toUpperCase()}
            </div>
          </Icon>
        </Tooltip>
      );
    }
  };

  // Renders the user select menu for user for debugging purposes

  // Render the navigation tabs
  private renderNav = () => {
    if (
      this.state.loggedInUser.emails !== undefined &&
      !this.props.currentUser
    ) {
      const email = this.state.loggedInUser.emails;
      //this.props.fetchUserData(email);
    }
    // this.props.fetchUserData(auth.this.state.loggedInUser.emails);
    const { classes, currentUser } = this.props;
    const { anchorEl, anchorMenu } = this.state;
    return (
      <div className={classes.navContainer}>
        {/* <div className={classes.navLink}> */}
        <Link className={classes.navLink} to="/">
          Home
        </Link>
        <div className={classes.navLinkSeparator} />
        {currentUser && currentUser.roleId !== UserRoles.Partner && (
          <React.Fragment>
            <Link className={classes.navLink} to="/home-ui">
              View Cases
            </Link>
            <div className={classes.navLinkSeparator} />
          </React.Fragment>
        )}
        {currentUser && (
          <div>
            <Button className={classes.navLink}
              style={{ textTransform: "capitalize" }}
              onClick={this.openManuTab}>
              New Case
            </Button>
            <Menu
              anchorEl={anchorMenu}
              keepMounted
              open={Boolean(anchorMenu)}
              onClose={this.handleCloseMenuTab}
              style={{ top: "40px" }}
            >
              {currentUser &&
                (currentUser.accessFor === AccessTypeEnum.STANDARD_UNICEF_COMPLAINT_CLAIM
                  || currentUser.accessFor === AccessTypeEnum.BOTH) ?
                <MenuItem onClick={this.handleCloseMenuTab}>
                  <Link to="/detail/new/mainform" onClick={() => this.props.newCase()}>
                    Standard UNICEF Complaint/Claim
                  </Link>
                </MenuItem>
                : ""
              }
              {
                currentUser
                  && (currentUser.accessFor === AccessTypeEnum.UNICEF_GAVI_INCIDENT_REPORT || currentUser.accessFor === AccessTypeEnum.BOTH)
                  && (window as any).showforInsuranceClaim ?
                  <MenuItem onClick={this.handleCloseMenuTab}>
                    <Link to="/detail/new/incident-mainform" onClick={() => this.props.newCase()}>
                      UNICEF/GAVI Incident Report
                    </Link>
                  </MenuItem>
                  : ""
              }
              {
                currentUser
                  && currentUser.isSDUser ?
                  <MenuItem onClick={this.handleCloseMenuTab}>
                    <Link to="/detail/new/wh-nonconformity-mainform" onClick={() => this.props.newCase()}>
                      Warehouse Nonconformity
                    </Link>
                  </MenuItem>
                  : ""
              }
            </Menu>
          </div>
        )}
        {currentUser && (
          <React.Fragment>
            <div className={classes.navLinkSeparator} />
            <div>
              <Button className={classes.navLink}
                style={{ textTransform: "capitalize" }}
                onClick={this.openHelpTab}>
                Help
              </Button>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={this.handleCloseHelpTab}
                style={{ top: "40px" }}
              >
                <MenuItem onClick={this.handleCloseHelpTab}>
                  <A href="help/Instructions_for_case_Submitter.pdf" target="_blank">
                    Instructions for case Submitter
                  </A>
                </MenuItem>

                {currentUser.roleId !== UserRoles.UNICEF && (
                  <MenuItem onClick={this.handleCloseHelpTab}>
                    <A href="help/Instructions_for_Solution_Owner_Focal_Point.pdf" target="_blank">
                      Instructions for Solution Owner/Focal Point
                    </A>
                  </MenuItem>
                )}
                {
                    currentUser.isSDUser && (
                        <MenuItem onClick={this.handleCloseHelpTab}>
                            <A href="help/WH_Nonconformities_200225.pdf" target="_blank">
                                Instructions for WH nonconformities submitters
                            </A>
                        </MenuItem>
                    )
                }
                <MenuItem onClick={this.handleCloseHelpTab}>
                  <A
                    href="https://unicef.sharepoint.com/teams/SD-eQMS/DL1/Forms/Division%20Procedures.aspx?web=1&FilterField1=DocumentName&FilterValue1=DP%20047-Handling%20complaints&FilterDisplay1=DP%20047-Handling%20complaints&FilterType1=Text&viewid=9a53c049-5e86-408e-be49-0e7a4baea7a5&id=/teams/SD-eQMS/DL1"
                    target="_blank"
                  >
                    DP 047 Handling Complaints
                  </A>
                </MenuItem>

                <MenuItem onClick={this.handleCloseHelpTab}>
                  <A
                    href="https://unicef.sharepoint.com/sites/portals/RF/Regulatory%20Framework%20Library/117345_UNICEF%20Procedure%20on%20Complaint%20Management.pdf"
                    target="_blank"
                  >
                    UNICEF Procedure on Complaint Management
                  </A>
                </MenuItem>

                <MenuItem onClick={this.handleCloseHelpTab}>
                  <A href="https://unicef.sharepoint.com/sites/SD/SitePages/InsuranceClaims.aspx" target="_blank">
                    Claims Info
                  </A>
                </MenuItem>
              </Menu>
            </div>
            {/* {currentUser && currentUser.roleId === UserRoles.QMU && (
              <React.Fragment>
                <div className={classes.navLinkSeparator} />
                <Link className={classes.navLink} to="/form-sp">
                  Add Solution Provider
                </Link>
              </React.Fragment>
            )} */}
            {currentUser && (currentUser.roleId === UserRoles.QMU ||
              currentUser.roleId === UserRoles.INS) && (
                <React.Fragment>
                  <div className={classes.navLinkSeparator} />
                  <Link className={classes.navLink} to="/users">
                    Users
                  </Link>
                </React.Fragment>
              )}
          </React.Fragment>
        )}

        {!this.state.isLoggedIn &&
          !(this.props.location.pathname.includes(ERROR_PATH) ||
            this.props.location.pathname.includes(ACCESS_REQUEST_PATH))
          &&
          (
            <React.Fragment>
              <Link
                href="#"
                onClick={() => this.loginRedirect()}
                to="/"
                className={classes.navLink}
                style={{ fontWeight: "bold" }}
              >
                Login
              </Link>
            </React.Fragment>
          )}
      </div>
    );
  };

  private openHelpTab = (event: any) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  private handleCloseHelpTab = () => {
    this.setState({
      anchorEl: null,
    });
  };

  private openManuTab = (event: any) => {
    this.setState({
      anchorMenu: event.currentTarget,
    });
  };

  private handleCloseMenuTab = () => {
    this.setState({
      anchorMenu: null,
    });
  };
}

function mapStateToProps(state: IRootState) {
  return {
    currentUser: state.home.currentUser,
    isUserAuthenticated: state.userProfile.isAuthenticated

  };
}

// 25.01. Q1 Redux dispatch the function fetchUserData via the Connect function to the Header component.
function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators(
      {
        fetchUserData, userDataReceived, newCase,
        loggedIn, resetAuthenticationStatus
      },
      dispatch
    ),
  };
}

const joinedStyles = (theme: Theme) =>
  createStyles({
    ...navStyles(theme),
    ...headerStyles(theme),
  });

export default withStyles(joinedStyles)(
  connect(mapStateToProps, mapDispatchToProps)(Header)
);

